var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAboutAppLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1926_2446)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.56 0H29.44C13.1807 0 0 13.1807 0 29.44V98.56C0 114.819 13.1807 128 29.44 128H98.56C114.819 128 128 114.819 128 98.56V29.44C128 13.1807 114.819 0 98.56 0Z",
    fill: "url(#paint0_linear_1926_2446)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.4277 28.3076C36.6384 28.3076 27.6895 37.6328 27.6895 63.9438H39.4584C39.4584 58.9493 39.6088 54.9311 40.2856 51.7021L56.8926 62.4167C56.993 62.4792 57.093 62.5417 57.1934 62.6042C60.0759 64.2692 62.1317 65.0953 65.4154 65.0953C68.7114 65.0953 70.7545 64.2692 73.6375 62.6042C73.7374 62.5417 73.8378 62.4792 73.9383 62.4167L90.4572 51.5017C91.2217 55.0818 91.3847 59.7252 91.3847 65.6959C91.3847 82.8194 89.0659 87.8133 65.5031 87.8261V99.5795C94.2297 99.5672 103.154 90.6924 103.154 65.6959C103.166 37.7454 94.5807 28.3076 65.4277 28.3076ZM68.8744 52.5031C66.7816 53.6423 64.0365 53.6546 61.9437 52.5031L47.3545 42.3893C51.2276 40.712 56.9428 40.0611 65.4277 40.0611C73.9132 40.0611 79.4526 40.5868 83.3133 42.189L68.8744 52.5031Z",
    fill: "url(#paint1_linear_1926_2446)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.563 82.9071V77.0363C50.563 73.7944 47.931 71.166 44.6848 71.166H33.5677C30.3215 71.166 27.6895 73.7944 27.6895 77.0363C27.6895 80.2781 30.3215 82.9071 33.5677 82.9071H50.563Z",
    fill: "url(#paint2_linear_1926_2446)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.393 87.9512H41.2884C38.0422 87.9512 35.4102 90.5796 35.4102 93.8219C35.4102 97.0638 38.0422 99.6922 41.2884 99.6922H58.2711V93.8219C58.2711 90.5796 55.6392 87.9512 52.393 87.9512Z",
    fill: "url(#paint3_linear_1926_2446)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1926_2446",
    x1: -2962.04,
    y1: 13965.3,
    x2: 11438,
    y2: 3651.51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D1C4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.982893,
    stopColor: "#4C31CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1926_2446",
    x1: -549.704,
    y1: 6074.17,
    x2: 7498.98,
    y2: 266.369,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.071783,
    stopColor: "white",
    stopOpacity: 0.38
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.275198,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.552083,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1926_2446",
    x1: 624.839,
    y1: 1220.83,
    x2: 1362.1,
    y2: 240.981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.071783,
    stopColor: "white",
    stopOpacity: 0.38
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.275198,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.552083,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1926_2446",
    x1: -139.502,
    y1: 795.49,
    x2: 598.012,
    y2: -184.701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.071783,
    stopColor: "white",
    stopOpacity: 0.38
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.275198,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.552083,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1926_2446"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 128,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutAppLogo);
export default __webpack_public_path__ + "static/media/about-app-logo.8b6fc6ae76836d7a56c9b7efa39124d9.svg";
export { ForwardRef as ReactComponent };